import type { SITE_GALLERY_VIEW_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/site-gallery-view/site-gallery-view.fr.ts";

export const SITE_GALLERY_VIEW_ENGLISH_LOCALE = {
  gallery: "Gallery",
  emptyTitle: "No photo",
  emptyDetails: "No photo available on this site for the moment",
} satisfies typeof SITE_GALLERY_VIEW_FRENCH_LOCALE;
